import SparkleIcon from '../../assets/icons/Vector.svg?react';
import {
  EASY_MODE_STEPS,
  EASY_MODE_STEP_LABELS,
  EASY_MODE_STEP_ORDER,
  isFirstEasyModeStep
} from '../../constants/easyModeSteps';
import { useEasyModeContext } from '../../contexts/EasyModeContext';
import useEasyModeFooterProps from '../../hooks/useEasyModeFooterProps';
import XLoader from '../common/XLoader';
import EasyModeContextStep from './EasyModeContextStep';
import EasyModeDocumentStep from './EasyModeDocumentStep';
import EasyModeFooter from './EasyModeFooter';
import EasyModeHero from './EasyModeHero';
import EasyModeIntakeStep from './EasyModeIntakeStep';
import EasyModeStepper from './EasyModeStepper';
import {
  cardClasses,
  cardFrameClasses,
  columnClasses,
  shellClasses,
  stepCardClasses
} from './easyModeClasses';

const STEP_COMPONENTS = {
  [EASY_MODE_STEPS.CASE_INTAKE]: EasyModeIntakeStep,
  [EASY_MODE_STEPS.DOCUMENT_UPLOAD]: EasyModeDocumentStep,
  [EASY_MODE_STEPS.DEMAND_GENERATION]: EasyModeContextStep
};

const STEPPER_STEPS = EASY_MODE_STEP_ORDER.map((step) => ({
  step,
  label: EASY_MODE_STEP_LABELS[step]
}));

const EasyModeContent = () => {
  const { step, isCaseLoading, goToStep, goToClassicIntake, documents } = useEasyModeContext();
  const { isPrimaryIconVisible, ...footerProps } = useEasyModeFooterProps();

  const ActiveStep = STEP_COMPONENTS[step];

  return (
    <section className="content-wrapper -mt-[60px]">
      <div className={shellClasses}>
        <div className={cardFrameClasses}>
          <div className={cardClasses}>
            {isCaseLoading ? (
              <XLoader />
            ) : (
              <div className={columnClasses}>
                <EasyModeHero
                  isClassicIntakeVisible={isFirstEasyModeStep(step)}
                  onGoToClassicIntake={goToClassicIntake}
                />
                <div className={stepCardClasses}>
                  <EasyModeStepper
                    steps={STEPPER_STEPS}
                    currentStep={step}
                    onStepClick={goToStep}
                    isNavigationDisabled={documents.isWorkInFlight}
                  />
                  <ActiveStep />
                </div>
              </div>
            )}
          </div>
        </div>
      </div>

      <EasyModeFooter
        {...footerProps}
        primaryIcon={isPrimaryIconVisible ? <SparkleIcon /> : null}
      />
    </section>
  );
};

export default EasyModeContent;
